var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.tableFrom.status,
                callback: function ($$v) {
                  _vm.$set(_vm.tableFrom, "status", $$v)
                },
                expression: "tableFrom.status",
              },
            },
            [
              _c("el-tab-pane", { attrs: { label: "待审核", name: "0" } }),
              _c("el-tab-pane", { attrs: { label: "已通过", name: "1" } }),
              _c("el-tab-pane", { attrs: { label: "已拒绝", name: "2" } }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "clearfix" },
            [
              _c(
                "el-form",
                { attrs: { inline: "", size: "small" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "订单号：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "180px" },
                        attrs: { placeholder: "订单号", clearable: "" },
                        model: {
                          value: _vm.tableFrom.orderNo,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "orderNo", $$v)
                          },
                          expression: "tableFrom.orderNo",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "手机号：" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "160px" },
                        attrs: { placeholder: "用户手机号", clearable: "" },
                        model: {
                          value: _vm.tableFrom.uidPhone,
                          callback: function ($$v) {
                            _vm.$set(_vm.tableFrom, "uidPhone", $$v)
                          },
                          expression: "tableFrom.uidPhone",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "时间选择：" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "260px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd",
                          format: "yyyy-MM-dd",
                          size: "small",
                          type: "daterange",
                          "start-placeholder": "开始时间",
                          "end-placeholder": "结束时间",
                        },
                        on: { change: _vm.onchangeTime },
                        model: {
                          value: _vm.timeVal,
                          callback: function ($$v) {
                            _vm.timeVal = $$v
                          },
                          expression: "timeVal",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getList(1)
                            },
                          },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c("el-button", { on: { click: _vm.handleReset } }, [
                        _vm._v("重置"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "box-card mt14" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "60" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderId", label: "订单ID", width: "80" },
              }),
              _c("el-table-column", {
                attrs: { prop: "orderNo", label: "订单号", "min-width": "150" },
              }),
              _c("el-table-column", {
                attrs: { prop: "uid", label: "用户UID", width: "80" },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nickname",
                  label: "用户昵称",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "phone", label: "手机号", width: "120" },
              }),
              _c("el-table-column", {
                attrs: { label: "商品信息", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.productImages
                          ? _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _vm._l(
                                  scope.row.productImages
                                    .split(",")
                                    .slice(0, 3),
                                  function (img, index) {
                                    return _c("el-image", {
                                      key: index,
                                      staticStyle: {
                                        width: "40px",
                                        height: "40px",
                                        "margin-right": "4px",
                                      },
                                      attrs: {
                                        src: img,
                                        "preview-src-list":
                                          scope.row.productImages.split(","),
                                        fit: "cover",
                                      },
                                    })
                                  }
                                ),
                                scope.row.productImages.split(",").length > 3
                                  ? _c(
                                      "span",
                                      { staticStyle: { color: "#999" } },
                                      [_vm._v("...")]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "margin-top": "4px",
                              "font-size": "12px",
                              color: "#666",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.productInfo || "-"))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { prop: "payAmount", label: "支付金额", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { label: "支付截图", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.payImage
                          ? _c("el-image", {
                              staticStyle: { width: "40px", height: "40px" },
                              attrs: {
                                src: scope.row.payImage.split(",")[0],
                                "preview-src-list":
                                  scope.row.payImage.split(","),
                                fit: "cover",
                              },
                            })
                          : _c("span", [_vm._v("-")]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审核状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status === 0
                                  ? "warning"
                                  : scope.row.status === 1
                                  ? "success"
                                  : "danger",
                              size: "small",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status === 0
                                    ? "待审核"
                                    : scope.row.status === 1
                                    ? "已通过"
                                    : "已拒绝"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "adminRemark",
                  label: "管理员备注",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "审核时间", "min-width": "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 1 && scope.row.approveTime
                          ? _c("span", [_vm._v(_vm._s(scope.row.approveTime))])
                          : _c("span", { staticStyle: { color: "#999" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "审核人", "min-width": "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.adminName
                          ? _c("span", [_vm._v(_vm._s(scope.row.adminName))])
                          : _c("span", { staticStyle: { color: "#999" } }, [
                              _vm._v("-"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "提交时间",
                  "min-width": "150",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "160", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.status === 0
                          ? [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReview(
                                        scope.row.id,
                                        true
                                      )
                                    },
                                  },
                                },
                                [_vm._v("通过")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticStyle: { color: "#f56c6c" },
                                  attrs: { type: "text", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReview(
                                        scope.row.id,
                                        false
                                      )
                                    },
                                  },
                                },
                                [_vm._v("拒绝")]
                              ),
                            ]
                          : _vm._e(),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDetail(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("详情")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "支付凭证详情",
            visible: _vm.detailDialogVisible,
            width: "700px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDialogVisible = $event
            },
          },
        },
        [
          _vm.detailData
            ? _c(
                "el-descriptions",
                { attrs: { column: 2, border: "", size: "small" } },
                [
                  _c("el-descriptions-item", { attrs: { label: "凭证ID" } }, [
                    _vm._v(_vm._s(_vm.detailData.id)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "订单ID" } }, [
                    _vm._v(_vm._s(_vm.detailData.orderId)),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单号", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailData.orderNo))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "用户UID" } }, [
                    _vm._v(_vm._s(_vm.detailData.uid)),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "支付金额" } }, [
                    _vm._v(_vm._s(_vm.detailData.payAmount) + " 元"),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "支付截图", span: 2 } },
                    [
                      _vm.detailData.payImage
                        ? _c(
                            "div",
                            { staticClass: "image-list" },
                            _vm._l(
                              _vm.detailData.payImage.split(","),
                              function (img, index) {
                                return _c("el-image", {
                                  key: index,
                                  staticStyle: {
                                    width: "80px",
                                    height: "80px",
                                    "margin-right": "8px",
                                  },
                                  attrs: {
                                    src: img,
                                    "preview-src-list":
                                      _vm.detailData.payImage.split(","),
                                    fit: "cover",
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _c("span", [_vm._v("无")]),
                    ]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "审核状态" } }, [
                    _vm._v(
                      _vm._s(
                        _vm.detailData.status === 0
                          ? "待审核"
                          : _vm.detailData.status === 1
                          ? "已通过"
                          : "已拒绝"
                      )
                    ),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "管理员备注" } },
                    [_vm._v(_vm._s(_vm.detailData.adminRemark || "-"))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "审核时间" } }, [
                    _vm._v(_vm._s(_vm.detailData.approveTime || "-")),
                  ]),
                  _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
                    _vm._v(_vm._s(_vm.detailData.adminName || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品图片", span: 2 } },
                    [
                      _vm.detailData.productImages
                        ? _c(
                            "div",
                            { staticClass: "image-list" },
                            _vm._l(
                              _vm.detailData.productImages.split(","),
                              function (img, index) {
                                return _c("el-image", {
                                  key: index,
                                  staticStyle: {
                                    width: "80px",
                                    height: "80px",
                                    "margin-right": "8px",
                                  },
                                  attrs: {
                                    src: img,
                                    "preview-src-list":
                                      _vm.detailData.productImages.split(","),
                                    fit: "cover",
                                  },
                                })
                              }
                            ),
                            1
                          )
                        : _c("span", [_vm._v("无")]),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "商品信息", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailData.productInfo || "-"))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "收货人姓名" } },
                    [_vm._v(_vm._s(_vm.detailData.orderRealName || "-"))]
                  ),
                  _c("el-descriptions-item", { attrs: { label: "收货电话" } }, [
                    _vm._v(_vm._s(_vm.detailData.orderUserPhone || "-")),
                  ]),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "收货地址", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailData.orderUserAddress || "-"))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单实际支付" } },
                    [
                      _vm._v(
                        _vm._s(_vm.detailData.orderPayPrice || "-") + " 元"
                      ),
                    ]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "订单状态" } },
                    [
                      _c(
                        "el-tag",
                        {
                          attrs: {
                            type:
                              _vm.detailData.orderStatus === 0
                                ? "warning"
                                : _vm.detailData.orderStatus === 3
                                ? "success"
                                : "info",
                            size: "small",
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(_vm.detailData.orderStatusStr || "-") +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "下单时间", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailData.orderCreateTime || "-"))]
                  ),
                  _c(
                    "el-descriptions-item",
                    { attrs: { label: "提交时间", span: 2 } },
                    [_vm._v(_vm._s(_vm.detailData.createTime))]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }